import Pages from '@pages';
import { enableParental } from '../../store/slices/user.slice';
import { pushRoute } from '../../store/thunks/route.thunk';
import { store } from '../../store/store';

function goToZapper() {
  store.dispatch(enableParental());
  store.dispatch(
    pushRoute({
      route: {
        Page: Pages.ZAPPER,
        overwrite: true,
      },
    })
  );
}

export default goToZapper;
